module.exports = __webpack_public_path__ + "static/media/reel1.fb09af1b.png";